import { useCallback } from 'react';

import { Button } from '@/components/design-system/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import ShiplexLogo from './ShiplexLogo';

export const NotFoundScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoBack = useCallback(() => {
    void navigate(-1);
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="absolute top-4 left-4">
        <ShiplexLogo color="darkBlue" />
      </div>

      <div className="flex flex-col items-center space-y-4 text-center">
        <div>
          <h1 className="text-primary text-5xl font-semibold">{t('notFound.title')}</h1>
          <p className="font-base py-10 text-lg text-black/65">{t('notFound.message')}</p>
        </div>

        <Button
          onClick={handleGoBack}
          className="text-primary border-primary hover:text-typography hover:bg-primary/90 mt-4 h-10 rounded-md border px-6 text-base font-medium shadow-sm transition"
        >
          {t('notFound.goBack')}
        </Button>
      </div>
    </div>
  );
};
